import AbstractFormulaVisitor from "./AbstractFormulaVisitor.js";

/**
 * Visitor returning "interesting nodes" of a given node. An
 * interesting node is a node for which the user would want to see the
 * value when detailing a given formula.
 *
 * For example, in the formula "Net sales - Dimension(Net sales,
 * Resultatenhet (1))", the interesting nodes are "Net sales" and the
 * dimension node.
 */
export class InterestingNodesFinderFormulaVisitor extends AbstractFormulaVisitor {
	visitAbstractNode(node) {
		return [node];
	}

	visitBinaryOperatorNode(node) {
		return [
			...node.getLeftOperand().accept(this),
			...node.getRightOperand().accept(this),
		];
	}

	visitConstantNode() {
		return [];
	}
}

/**
 * Todo: Add JSDoc comment
 */
export function findInterestingNodes(node) {
	const visitor = new InterestingNodesFinderFormulaVisitor();

	return visitor
		.visit(node)
		.filter((interestingNode) => interestingNode !== node);
}
